export const SET_MATERIALS = 'ST_SET_MATERIALS';
export const ADD_MATERIAL = 'ST_ADD_MATERIAL';
export const REMOVE_MATERIAL = 'ST_REMOVE_MATERIAL';
export const TOGGLE_MATERIAL = 'ST_TOGGLE_MATERIAL';
export const TOGGLE_MATERIAL_SELECTION = 'ST_TOGGLE_MATERIAL_SELECTION';

export const SET_SUBJECTS = 'ST_SET_SUBJECTS';
export const ADD_SUBJECT = 'ST_ADD_SUBJECT';
export const REMOVE_SUBJECT = 'ST_REMOVE_SUBJECT';
export const TOGGLE_SUBJECT = 'ST_TOGGLE_SUBJECT';
export const SET_SELECTED_SUBJECTS = 'ST_SET_SELECTED_SUBJECTS';
export const TOGGLE_SUBJECT_SELECTION = 'ST_TOGGLE_SUBJECT_SELECTION';
export const REMOVE_SUBJECT_SELECTION = 'ST_REMOVE_SUBJECT_SELECTION';

export function setMaterials(materials, elementId) {
    return {
        type: SET_MATERIALS,
        elementId,
        payload: materials,
    };
}

export function addMaterial(material, elementId) {
    return {
        type: ADD_MATERIAL,
        elementId,
        payload: material,
    };
}

export function removeMaterial(material, elementId) {
    return {
        type: REMOVE_MATERIAL,
        elementId,
        payload: material,
    };
}

export function toggleMaterial(material, elementId) {
    return {
        type: TOGGLE_MATERIAL,
        elementId,
        payload: material,
    };
}

export function toggleMaterialSelection(material, elementId) {
    return {
        type: TOGGLE_MATERIAL_SELECTION,
        elementId,
        payload: material,
    };
}


export function setSubjects(subjects, elementId) {
    return {
        type: SET_SUBJECTS,
        elementId,
        payload: subjects,
    };
}

export function addSubject(subject, elementId) {
    return {
        type: ADD_SUBJECT,
        elementId,
        payload: subject,
    };
}

export function removeSubject(subject, elementId) {
    return {
        type: REMOVE_SUBJECT,
        elementId,
        payload: subject,
    };
}

export function toggleSubject(subject, elementId) {
    return {
        type: TOGGLE_SUBJECT,
        elementId,
        payload: subject,
    };
}

export function setSelectedSubjects(subjects, elementId) {
    return {
        type: SET_SELECTED_SUBJECTS,
        elementId,
        payload: subjects,
    };
}

export function toggleSubjectSelection(subject, elementId) {
    return {
        type: TOGGLE_SUBJECT_SELECTION,
        elementId,
        payload: subject,
    };
}

export function removeSubjectSelection(id, elementId) {
    return {
        type: REMOVE_SUBJECT_SELECTION,
        elementId,
        payload: id,
    };
}
